import React, { useEffect } from "react";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { updatePartnerDetails } from "../../../slices/partner/action";
import { useDispatch } from "react-redux";
import { alertError, alertSuccess } from "../../../helpers/errorHandling";

const BasicInfoForm = ({ onNext, partnerDetails, handleUpdate }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useDispatch();

  const validation = useFormik({
    initialValues: {
      partnerName: "",
      partnerLogo: "",
      primaryContactName: "",
      email: "",
      phoneNumber: "",
    },
    validationSchema: Yup.object({
      partnerName: Yup.string().required("Please Enter Partner Name"),
      email: Yup.string()
        .email("Invalid email format")
        .required("Please Enter Email"),
      phoneNumber: Yup.string().required("Please Enter Phone Number"),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const res = await updatePartnerDetails(values, dispatch);

        if (res?._id) {
          alertSuccess("Updated Successfully");
        } else {
          alertError({ message: "Failed, Please try again" });
        }

        handleUpdate();
        setTimeout(() => {
          setIsLoading(false);
        }, 1500);
      } catch (e) {
        console.log(e);
      }
    },
  });

  useEffect(() => {
    if (partnerDetails) {
      validation.setValues({
        partnerName: partnerDetails.partnerName || "",
        partnerLogo: partnerDetails.partnerLogo || "",
        primaryContactName: partnerDetails.primaryContactName || "",
        email: partnerDetails.email || "",
        phoneNumber: partnerDetails.phoneNumber || "",
      });
    }
  }, [partnerDetails]);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
      }}
    >
      <Row>
        <Col md={12} className="mb-3">
          <Label>Partner Name</Label>
          <Input
            name="partnerName"
            placeholder="Enter Partner Name"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.partnerName}
            invalid={
              validation.touched.partnerName && !!validation.errors.partnerName
            }
          />
          <FormFeedback>{validation.errors.partnerName}</FormFeedback>
        </Col>

        <Col md={12} className="mb-3">
          <Label>Primary Contact Name</Label>
          <Input
            name="primaryContactName"
            placeholder="Enter Primary Contact Name"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.primaryContactName}
          />
        </Col>

        <Col md={12} className="mb-3">
          <Label>Email</Label>
          <Input
            name="email"
            type="email"
            placeholder="Enter Email"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.email}
            invalid={validation.touched.email && !!validation.errors.email}
            disabled
          />
          <FormFeedback>{validation.errors.email}</FormFeedback>
        </Col>

        <Col md={12} className="mb-3">
          <Label>Phone Number</Label>
          <Input
            name="phoneNumber"
            placeholder="Enter Phone Number"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.phoneNumber}
            invalid={
              validation.touched.phoneNumber && !!validation.errors.phoneNumber
            }
            disabled
          />
          <FormFeedback>{validation.errors.phoneNumber}</FormFeedback>
        </Col>
      </Row>

      <Button
        color="primary"
        type="submit"
        className="w-auto"
        disabled={isLoading}
        size="sm"
      >
        {isLoading ? <Spinner size="sm" /> : "Save"}
      </Button>
    </Form>
  );
};

export default BasicInfoForm;
BasicInfoForm.propTypes = {
  onNext: PropTypes.func.isRequired,
  partnerDetails: PropTypes.object.isRequired,
  handleUpdate: PropTypes.func.isRequired,
};
